import React, { FunctionComponent } from 'react'
import TSConstants from '../../../utils/TSConstants'
import CONFIG from '../../../model/TSConfig'
import { lotteryConfigSelector } from '../../../redux/selectors/lottery'
import { useSelector } from 'react-redux'
import { QuizzSkinI } from '../skins/default'

interface Props {
  containerClass?: string
  useConfig?: boolean
  isHome?: boolean
  skin?: QuizzSkinI
}

const QuizzLogo: FunctionComponent<Props> = ({
  containerClass,
  useConfig,
  isHome = false,
  skin,
}) => {
  const lotteryConfig = useSelector(lotteryConfigSelector)

  let logoHeight
  let logoSrc: string | undefined
  if (
    lotteryConfig &&
    lotteryConfig.customizeColors &&
    lotteryConfig?.logoURL
  ) {
    logoHeight =
      (lotteryConfig &&
        lotteryConfig.customizeColors &&
        lotteryConfig?.logoHeight) ||
      undefined
    logoSrc = `image:/cdm/${CONFIG.CUSTOMER_LOGO_FILES_FOLDER}/${lotteryConfig?.logoURL}`
  } else {
    logoHeight = lotteryConfig?.logoHeight || 80
    logoSrc = `image:/cdm/kadow/img/logo_2.png`
  }

  if (isHome) {
    const skinLogo = skin?.replaceHomeLogo()
    if (skinLogo) {
      return skinLogo as JSX.Element
    }
  }

  return (
    <>
      <div className={containerClass}>
        {!!logoSrc && (
          <img
            className="logo logo-quizz twic"
            src={TSConstants.PLACEHOLDER_URL}
            data-src={logoSrc}
            data-src-transform="contain=WxH"
            style={{
              height: useConfig ? logoHeight : undefined,
              width: 'auto',
            }}
            alt="logo"
          />
        )}
      </div>
    </>
  )
}

export default QuizzLogo
